export default __webpack_public_path__ + "static/media/add-or-remove-from-list.12953c99.svg";